import { logger } from '@lusha/client-logger';
import { autorun } from 'mobx';
import { flow, getRoot } from 'mobx-state-tree';
import { fetchCommunitySettings, fetchCommunityStatus, fetchOutlookDesktopConnectionSettings, } from '../../../API/communityAPI';
import { fromJsonToQueryString } from '../../../utils/queryBuilder';
import { COMMUNITY_STATUS, ELEMENTS_TYPES } from '../constants';
const Actions = self => ({
    afterCreate() {
        autorun(() => {
            const { user: { id, isLoaded }, } = getRoot(self);
            if (id && isLoaded) {
                self.fetchData();
            }
        });
    },
    fetchData() {
        self.fetchCommunityData();
        self.fetchIsOutlookDesktopConnected();
    },
    setDisplayFirstShowBanner(setter) {
        self.displayFirstShowBanner = setter;
    },
    fetchCommunityData: flow(function* fetchCommunityData(query = {}) {
        var _a, _b, _c, _d, _e, _f;
        try {
            self.isLoaded = false;
            const { billing, id, isAccountSuspended } = getRoot(self).user;
            if (isAccountSuspended || (billing === null || billing === void 0 ? void 0 : billing.isPaid)) {
                return Promise.resolve(COMMUNITY_STATUS.COMMUNITY_IRRELEVANT);
            }
            const communitySettings = yield fetchCommunitySettings(id);
            self.isComposedEnabled = communitySettings.isComposedEnabled;
            self.isCommunityTermsAccepted = communitySettings.isCommunityTermsAccepted;
            self.firstCommunityTabVisit = (_a = communitySettings === null || communitySettings === void 0 ? void 0 : communitySettings.analytics) === null || _a === void 0 ? void 0 : _a.firstCommunityTabVisit;
            self.inviteNextAppearance = (_b = communitySettings === null || communitySettings === void 0 ? void 0 : communitySettings.analytics) === null || _b === void 0 ? void 0 : _b.inviteNextAppearance;
            self.inviteDismissCount = ((_c = communitySettings === null || communitySettings === void 0 ? void 0 : communitySettings.analytics) === null || _c === void 0 ? void 0 : _c.inviteDismissCount) || 0;
            self.reminderNextAppearance = (_d = communitySettings === null || communitySettings === void 0 ? void 0 : communitySettings.analytics) === null || _d === void 0 ? void 0 : _d.reminderNextAppearance;
            self.reminderDismissCount = ((_e = communitySettings === null || communitySettings === void 0 ? void 0 : communitySettings.analytics) === null || _e === void 0 ? void 0 : _e.reminderDismissCount) || 0;
            self.outlookExeDownloadDate = ((_f = communitySettings === null || communitySettings === void 0 ? void 0 : communitySettings.analytics) === null || _f === void 0 ? void 0 : _f.outlookExeDownloadDate) || '';
            self.sourceValidationStatus = communitySettings === null || communitySettings === void 0 ? void 0 : communitySettings.sourceValidationStatus;
            const queryString = fromJsonToQueryString(query);
            const { status, segment } = yield fetchCommunityStatus(queryString);
            self.segment = segment || '';
            switch (status) {
                case COMMUNITY_STATUS.COMMUNITY_CANDIDATE:
                case COMMUNITY_STATUS.INACTIVE_COMMUNITY_MEMBER:
                case COMMUNITY_STATUS.LEFT_COMMUNITY:
                case COMMUNITY_STATUS.COMMUNITY_MEMBER:
                case COMMUNITY_STATUS.COMMUNITY_PENDING_JOIN_VALIDATION:
                    self.status = status;
                    break;
                case COMMUNITY_STATUS.COMMUNITY_IRRELEVANT:
                default:
                    self.status = COMMUNITY_STATUS.COMMUNITY_IRRELEVANT;
                    break;
            }
            if ((query === null || query === void 0 ? void 0 : query.firstShow) && self.status === COMMUNITY_STATUS.COMMUNITY_CANDIDATE) {
                self.displayFirstShowBanner = true;
            }
            self.isLoaded = true;
            return self.status;
        }
        catch (e) {
            logger.warn('Error fetching community status', e);
            self.isLoaded = true;
            self.status = COMMUNITY_STATUS.COMMUNITY_IRRELEVANT;
            return COMMUNITY_STATUS.COMMUNITY_IRRELEVANT;
        }
    }),
    fetchIsOutlookDesktopConnected: flow(function* fetchIsOutlookDesktopConnected() {
        var _a;
        try {
            self.isOutlookSettingsLoaded = false;
            const { isAccountSuspended, billing } = getRoot(self).user;
            if (isAccountSuspended || (billing === null || billing === void 0 ? void 0 : billing.isPaid)) {
                return;
            }
            const outlookSettings = yield fetchOutlookDesktopConnectionSettings();
            self.isOutlookDesktopConnected = ((_a = outlookSettings === null || outlookSettings === void 0 ? void 0 : outlookSettings.data) === null || _a === void 0 ? void 0 : _a.status) === 'enabled';
            self.isOutlookSettingsLoaded = true;
        }
        catch (e) {
            self.isOutlookSettingsLoaded = true;
            logger.warn('Error fetching outlook settings', e);
        }
    }),
    updateElementReappearanceData(dismissCount, nextAppearanceDate, elementType) {
        if (elementType === ELEMENTS_TYPES.COMMUNITY_INVITE) {
            self.inviteNextAppearance = nextAppearanceDate;
            self.inviteDismissCount = dismissCount;
        }
        else {
            self.reminderNextAppearance = nextAppearanceDate;
            self.reminderDismissCount = dismissCount;
        }
    },
    setIsBannerDisplayed(value) {
        self.isBannerDisplayed = value;
    },
});
export default Actions;
